export default "__VITE_ASSET__A$w2C7EY__"